// extracted by mini-css-extract-plugin
export default {"headerBar":"zL-z","pointsSection":"AL-z","goToDashboard":"BL-z"};